var Reflux = require('reflux');
var DappsActions = require('../actions/DappsActions');

const server = 'https://dappstore.link/';
//const server = 'http://store.zaxid.media/';

var UsersStore = Reflux.createStore({
    data: {
        transactions: {},
    },
    listenables: [DappsActions],
    init: function() {
        /*
        this.getDataPromise.then(function(e) {
            UsersStore.data.transactions = e;
            UsersStore.doTrigger();
        });
        */
    },
    // getDataPromise: fetch(server + 'api/get-user-data?address=0x3797cf7779fe48161afe2ee1c10567bd32e6e9d5').then(r => r.json()),
    doTrigger: function() {
        this.trigger(this.data);
    },
    getUserPromise: function(user) {
        return new Promise(function(resolve) {
            if (typeof UsersStore.data.transactions[user] !== "undefined" ) {
                resolve(UsersStore.data.transactions[user]);
            } else {
                fetch(server + 'api/get-user-data?address=' + user).then(r => r.json()).then(function(data){
                    UsersStore.data.transactions[user] = data;
                    UsersStore.doTrigger();
                    resolve(UsersStore.data.transactions[user]);
                });
            }
        });
    },
});

module.exports = UsersStore;



// WEBPACK FOOTER //
// ./src/stores/UsersStore.js